import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import MarcaService from "./marcaService"
import FormList from 'base/FormList'
import { InputSwitch } from 'primereact/inputswitch'

export default function MarcaList() {

    const [service] = useState(() => new MarcaService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_marc',
        dsName: 'descricao_marc',
        mainField: { name: 'descricao_marc', label: 'Descrição' },
        advFields: [
            { name: 'codigo_marc', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_marc', label: 'Descrição', type: 'string', inputMode: 'text' },
            { name: 'ativo_marc', label: 'Ativo', type: 'boolean', component: 'TriStateCheckbox', value: null },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="descricao_marc" sortable header="Descrição"></Column>
            <Column field="ativo_marc" sortable header="Ativo" body={e => <InputSwitch checked={e.ativo_marc === 1}></InputSwitch>}></Column>
        </FormList >
    )
}
